module.exports = __webpack_public_path__ + "static/media/icon_close_white.dc4d7310.svg";